import React, { useState } from 'react';

const FormField = ({ label, name, type = 'text', value, onChange, hasError, options = [], selector, icon, showToplabel = false, readOnly = false }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const containerStyle = {
    width: '100%',
    marginBottom: '0px',
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '4px',
    fontSize: '20px',
    fontWeight: '450',
  };

  const commonStyle = {
    display: 'block',
    width: '100%',
    minWidth: '180px',
    fontSize: '20px',
    border: 'none',                 // ❌ remove full border
    borderBottom: '2px solid #050505', // ✅ bottom line only
    borderTop: '0px transparent', // ✅ bottom line only
    borderLeft: '0px transparent',
    borderRight: '0px transparent',
    borderRadius: '0',              // ❌ remove rounding
    boxSizing: 'border-box',
    height: '40px',
    lineHeight: '24px',
    marginTop: '0',
    marginBottom: '15px',
    textAlign: 'center',
    backgroundColor: 'transparent', // ✅ transparent background
    color: '#000000',                  // ✅ white text (important for dark bg)
    outline: 'none',                // remove blue focus outline
  };

  const iconStyle = {
  position: 'absolute',
  left: '10px',
  top: '50%',
  transform: 'translateY(-50%)',
  color: '#000000',
  fontSize: '16px',
  pointerEvents: 'none',
};


  const getInputStyle = (hasError) => ({
    ...commonStyle,
    border: hasError ? '1px solid #dc3545' : '1px solid #ccc',
  });

const handleSelect = (selectedValue) => {
  if (readOnly) return;
  onChange({ target: { name, value: selectedValue } });
  setDropdownOpen(false);
};

  return (
    <div className='formField d-flex flex-column justify-content-center align-items-center' style={containerStyle}>

    <style>
      {`
        .form-input::placeholder {
          color: #000000;
          font-size: 20px;
          opacity: 1;
        }

        .input-with-icon::placeholder {
          text-align: left;
          padding-left: 10px;
        }

        .form-input:not(.input-with-icon)::placeholder {
          text-align: center;
        }
      `}
    </style>

  {/* your existing JSX below */}

        {/* can we activate or deactivate this, so in some forms is displayed and in others is not */}
      
      {showToplabel && label && <label htmlFor={name} style={labelStyle}>{label}</label>}

      {type === 'select' ? (
        <div className="dropdown " style={{ width: '100%', position: 'relative' }}>
          <div
            className='d-flex justify-content-center align-items-center m-0 p-0'
            onClick={() => {
              if (!readOnly) {
                setDropdownOpen(!dropdownOpen);
              }
            }}
            style={{
  ...getInputStyle(hasError),
  backgroundColor: readOnly ? "#f5f5f547" : "transparent",
  cursor: readOnly ? "not-allowed" : "pointer",
  opacity: readOnly ? 0.7 : 1
}}
          >
            {/* lets add some console.log here to see what we have */}
            {/* {value
              ? options.find(opt => opt.value === value)?.label
              : label || 'Select...'} */}
              {/* {(() => {
                console.log("SELECT DEBUG →");
                console.log("value:", value, typeof value);
                console.log("options:", options);

                const found = options.find(opt => opt.value === value);
                console.log("found:", found);

                return value
                  ? found?.label
                  : label || 'Select...';
              })()} */}
              {value === ""
  ? label || 'Select...'
  : options.find(opt => opt.value === value)?.label}
          </div>
          {dropdownOpen && (
            <ul
              className="dropdown-menu show"
              style={{
                fontSize: '20px',
                display: 'block',
                maxHeight: '100px',
                overflowY: 'auto',
                width: '100%',
                padding: '0',
                margin: '0',
                position: 'absolute',
                textAlign: 'center',
                zIndex: 1000,
              }}
            >
              {options.map((opt) => (
                <li style={{ fontSize: '20px' }} key={opt.value}>
                  <button
                    type="button"
                    className="dropdown-item"
                    style={{ fontSize: '20px' }}
                    onClick={() => handleSelect(opt.value)}
                  >
                    {opt.label}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
) : type === 'date' ? (
  <>
    {label && !showToplabel && (
      <label htmlFor={name} style={labelStyle}>
        {label}
      </label>
    )}
<input
  id={name}
  type="date"
  name={name}
  value={value}
  onChange={readOnly ? undefined : onChange}
  readOnly={readOnly}
  disabled={readOnly}
  style={{
    ...getInputStyle(hasError),
    padding: '0',
    backgroundColor: readOnly ? "#f5f5f541" : "transparent",
    cursor: readOnly ? "not-allowed" : "pointer"
  }}
/>
  </>


) : (
  <div style={{ position: 'relative', width: '100%' }}>
    {icon && (
      <img
        src={icon}
        alt="icon"
        style={{
          position: 'absolute',
          left: '10px',
          top: '50%',
          transform: 'translateY(-80%)',
          width: '9%',
          height: '70%',
          pointerEvents: 'none',
          objectFit: 'contain',
        }}
      />
    )}

<input
  id={name}
  type={type}
  name={name}
  value={value}
  onChange={readOnly ? undefined : onChange}
  readOnly={readOnly}
  disabled={readOnly}
  placeholder={label}
  className={`form-input ${icon ? "input-with-icon" : ""}`}
  style={{
    ...getInputStyle(hasError),
    paddingLeft: icon ? '60px' : '0px',
    width: "100%",
    textAlign: icon ? "left" : "center",
    backgroundColor: readOnly ? "#f5f5f535" : "transparent",
    cursor: readOnly ? "not-allowed" : "text"
  }}
/>
  </div>
)}

    </div>
  );
};

export default FormField;
